import { isValidArray } from "helpers/validation";

const pendingApplicants = (applicants) => {
    if( isValidArray(applicants) == false ){ return []; }
    const result = applicants.filter( (applicant) => (applicant.status === 'applied' || applicant.status === 'nominated'));
    return result;
}

const approvedApplicants = (applicants) => {
    if( isValidArray(applicants) == false ){ return []; }
    const result = applicants.filter( (applicant) => (applicant.status === 'picked'));
    return result;
}

const deniedApplicants = (applicants) => {
    if( isValidArray(applicants) == false ){ return []; }
    const result = applicants.filter( (applicant) => (applicant.status === 'denied'));
    return result;
}

const commentsForApplicant = (applicantId, dict) => {
    const comments = dict[applicantId];
    if( comments == null ){ 
        return []; 
    }else{
        return comments;
    }
}

const getApplicantById = (applicantId, applicants) => {
    if( isValidArray(applicants) == false ){ return null; }
    if( applicantId == null ){ return null; }
    const applicant = applicants.find( (applicant) => (applicant.id == applicantId));
    return applicant;
}

const getApplicantByUserId = (userId, applicants) => {
    if( isValidArray(applicants) == false ){ return null; }
    if( userId == null ){ return null; }
    const applicant = applicants.find( (applicant) => (applicant.user_id == userId));
    return applicant;
}

const firstPendingApplicantId = (applicants) => {
    const pending = pendingApplicants(applicants);
    if( isValidArray(pending) == false ){ return null; }
    const applicant = pending[0];
    if( applicant == null ){ return null; }
    return applicant.id;
}

const firstApprovedApplicantId = (applicants) => {
    const approved = approvedApplicants(applicants);
    if( isValidArray(approved) == false ){ return null; }
    const applicant = approved[0];
    if( applicant == null ){ return null; }
    return applicant.id;
}

const applicantIdToBeAutoSelected = (shift, applicants) => {
    if ( shift.name == 'open_shift' ){
        return firstPendingApplicantId(applicants);
    }else if ( shift.name == 'shift' ){
        if ( shift.trade_status == 'approved' || shift.trade_status == 'covered' ){
            return firstApprovedApplicantId(applicants);
        }else{
            return firstPendingApplicantId(applicants);
        }
    }
    return null;
}

export default {
    pendingApplicants,
    approvedApplicants,
    deniedApplicants,
    commentsForApplicant,
    getApplicantById,
    firstPendingApplicantId,
    applicantIdToBeAutoSelected,
}